import {Component, EventEmitter, HostListener, Input, Output} from "@angular/core";

@Component({
	selector: "modal",
	template: `
		<div class="modal_blocker" (click)="clickToClose && close($event)"></div>
		<aside class="modal modal-open" [ngClass]="modalClasses">
			<ng-content></ng-content>
			<a *ngIf="showCloseButton" href="#" class="modal_close" (click)="close($event)"></a>
		</aside>
	`,
})
export class ModalComponent {
	@Input() showCloseButton = true;
	@Input() escapeToClose = true;
	@Input() clickToClose = true;
	@Input() modalClasses: string | Array<string> = "";

	@Output("close") closed = new EventEmitter<void>();

	close(event: Event) {
		event.preventDefault();
		event.stopPropagation();
		this.closed.emit();
	}

	@HostListener("document:keydown", ["$event"])
	keydown(event: KeyboardEvent) {
		if (this.escapeToClose && event.which === 27)
			this.close(event);
	}
}
